import React, { useMemo } from "react";
import { Skeleton } from "antd";
import { ThunderboltOutlined, ArrowRightOutlined } from "@ant-design/icons";
import { formatWithCommas } from "../../../assets/helpers";
import PanelCard from "./PanelCard";
import "./IntensityStrip.scss";

/* Low -> high intensity ramp, kept inside the existing brand palette. */
const RAMP = ["#36a546", "#7ec242", "#ffa52f", "#ff8a4b", "#ff6843", "#e14b2b"];

const IntensityStrip = ({
  items = [],
  loading = false,
  onSelect,
  title = "Case Intensity",
  subtitle = "Portfolio split by collection difficulty — select a band to drill in",
}) => {
  const total = useMemo(
    () => items.reduce((sum, i) => sum + (Number(i?.count) || 0), 0),
    [items],
  );

  if (!loading && !items.length) return null;

  return (
    <PanelCard
      title={title}
      subtitle={subtitle}
      icon={<ThunderboltOutlined />}
      accent="violet"
      className="dsh-intensity"
    >
      {loading ? (
        <Skeleton active paragraph={{ rows: 2 }} />
      ) : (
        <div className="dsh-intensity__grid">
          {items.map((item, i) => {
            const count = Number(item?.count) || 0;
            const share = total ? Math.round((count / total) * 100) : 0;
            const color = RAMP[i % RAMP.length];
            return (
              <button
                type="button"
                key={item?.intensity ?? i}
                className="dsh-intensity__chip"
                style={{ "--chip-color": color }}
                onClick={() => onSelect?.(item)}
              >
                <span className="dsh-intensity__head">
                  <span className="dsh-intensity__badge">
                    Intensity {item?.intensity}
                  </span>
                  <ArrowRightOutlined className="dsh-intensity__go" />
                </span>
                <span className="dsh-intensity__count">
                  {formatWithCommas(count)}
                </span>
                <span className="dsh-intensity__meter">
                  <i style={{ width: `${share}%` }} />
                </span>
                <span className="dsh-intensity__share">
                  {share}% of portfolio
                </span>
              </button>
            );
          })}
        </div>
      )}
    </PanelCard>
  );
};

export default IntensityStrip;
